<script setup></script>

<template>
  <div class="app-container">
    <Header />
    <Contact />
    <!-- 路由视图 -->
    <div class="app-main">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<style scoped>
.app-container {
  min-height: 100vh;

}
.color-gradient {
  background: linear-gradient(50.21918117194974deg, #fa932a 0%, #fa5f31 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>
